import * as React from 'react';

import RunningIndicator from '../../assets/RunningIndicator.svg';
import {ClassNameBuilder} from '../../utils/ClassNameBuilder';
import {Icon} from '../Icon/Icon';

import * as Styles from './Cell.module.scss';

interface Props extends React.HTMLAttributes<HTMLElement> {
    text?: string;
    image?: React.ReactElement;
    className?: string;
    onClick?: (event: React.MouseEvent) => void;
    mouseEffects?: boolean;
    indicator?: boolean;
    children?: React.ReactNode;
    actions?: React.ReactNode;
    title?: string;
}

export const CellDetailed = React.forwardRef((props: Props, ref: React.RefObject<HTMLDivElement>) => {
    const {image, onClick, title, mouseEffects, indicator, className, children, actions, ...rest} = props;

    const containerClass = new ClassNameBuilder(Styles, 'cell')
        .add(className)
        .add(['mouse-effects', !!onClick || !!mouseEffects])
        .add('default-modifiers')
        .toString();

    return (
        <div className={containerClass} onClick={onClick} ref={ref} {...rest} title={title}>
            {indicator && <Icon src={RunningIndicator} className={Styles['running-indicator']} />}

            {image &&
                <div className={Styles['image']}>
                    {image}
                </div>
            }
            <span className={Styles['content']}>{children}</span>

            <div className={Styles['actions-container']}>{actions}</div>
        </div>
    );
});

export const Cell = React.forwardRef((props: Props, ref: React.RefObject<HTMLDivElement>) => {
    return <CellDetailed {...props} ref={ref} actions={props.children} title={props.text}>
        {props.text}
    </CellDetailed>;
});
